import React from 'react';
import { Link } from 'react-router-dom';
import { Badge, Col, Row } from 'reactstrap';

const MONTHS_MAPPER = {
  0: 'Jan',
  1: 'Feb',
  2: 'Mar',
  3: 'Apr',
  4: 'May',
  5: 'Jun',
  6: 'Jul',
  7: 'Aug',
  8: 'Sep',
  9: 'Oct',
  10: 'Nov',
  11: 'Dec',
};
class NotificationMenuItem extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      visible: true,
    };
  }

  closeThis = () => {
    this.props.notificationsMessagesSeen(this.props.id);
  };

  openAddFriendModal = (user, id) => {
    this.props.openAddFriendModal(user, id);
  };

  render() {
    const readMore = this.props.readMore ? (
      <Link to={this.props.readMore}>Read More</Link>
    ) : null;

    const divClass =
      this.state.visible === true
        ? 'notification-menu-item'
        : 'notification-menu-item hide';

    const date = new Date(Number(this.props.startDate || this.props.createdAt));

    if (this.props.isFriendNotification) {
      const name =
        this.props.user_from_object.username &&
        this.props.user_from_object.username !== ''
          ? this.props.user_from_object.username
          : this.props.user_from_object.lastName;

      return (
        <div className={divClass}>
          <Row>
            <Col className="d-flex justify-content-between">
              <span className="default date">{`${
                MONTHS_MAPPER[date.getMonth()]
              } ${date.getDate()}`}</span>
            </Col>
          </Row>
          <Row>
            <Col>
              {`${name} wants to add you as a friend.`}
              <span
                className="read-more"
                onClick={() =>
                  this.openAddFriendModal(
                    this.props.user_from_object,
                    this.props.id,
                  )
                }
              >
                {' '}
                Read More
              </span>
            </Col>
          </Row>
        </div>
      );
    }

    return (
      <div className={divClass}>
        <Row>
          <Col className="d-flex justify-content-between">
            <span className="default date">{`${
              MONTHS_MAPPER[date.getMonth()]
            } ${date.getDate()}`}</span>
          </Col>
          <Col className="d-flex justify-content-between">
            <span className="default date">{this.props.date}</span>
            <Badge
              color="default"
              onClick={this.closeThis}
              className="d-flex circle"
            >
              X
            </Badge>
          </Col>
        </Row>
        <Row>
          <Col>
            {this.props.name} {} {readMore}
          </Col>
        </Row>
      </div>
    );
  }
}

export default NotificationMenuItem;
